import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { pairwise } from 'rxjs/operators';
import { ModalDialogType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { PosCreditRequestCompanyBankingReferencesModalService } from 'src/app/@core/services/pos-credit-request-company-banking-references-modal.service';
import { ObjectUtils } from 'src/app/@core/utils/object-utils';
import { ColumnTable } from 'src/app/models/column-table';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import { Paging } from 'src/app/models/page';
import { BankingReferenceTable } from 'src/app/models/table-models/banking-reference-table';
import { OnbaseService } from 'src/app/services/onbase.service';


@Component({
  selector: 'pos-company-bank-references-step',
  templateUrl: './company-bank-references-step.component.html',
  styleUrls: ['./company-bank-references-step.component.sass']
})
export class CompanyBankReferencesStepComponent implements OnInit {



  constructor(private companyModal: PosCreditRequestCompanyBankingReferencesModalService, private confirmService: PosConfirmationService, private onbaseService: OnbaseService) { }

  @Input() companyBankingReferenceForm: FormArray = new FormArray([]);
  @Input() disabled = false;
  bankingReferenceTable: Paging<Array<BankingReferenceTable>> = new Paging([]);
  @Input() isEdit = false;
  @Input() onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();
  contactPositions: Array<{ key: string, value: string }> = [];
  async ngOnInit(): Promise<void> {
    this.companyBankingReferenceForm.valueChanges.subscribe(async s => {
      if (this.onbaseCatalogue.economicActivity.length == 0) {
        this.onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
      }
      this.contactPositions = ObjectUtils.objectToArray(this.onbaseCatalogue.legalRelation);
      if (this.isEdit) {
        this.bankingReferenceTable = new Paging([]);
        (s as Array<any>).forEach((f, i) => {
          this.bankingReferenceTable.content.push({
            code: i,
            relationshipType: this.contactPositions.find(s => s.key == f.relationshipType)?.value || f.relationshipType,
            name: `${f.institutionName}`,
            phone: f.phone,
            status: this.companyBankingReferenceForm.at(i).valid
          });


        })
        this.bankingReferenceTable = new Paging(this.bankingReferenceTable.content);
      }
    });

  }

  getBankingReferenceTableHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable("name", "Nombre de la Institución"),
      new ColumnTable("phone", "Teléfono"),
      new ColumnTable("relationshipType", "Tipo de Relación"),
      new ColumnTable("status", "Estado", { type: "hidden" }),
      new ColumnTable("code", "Opciones", {
        type: "action", actions: [
          {
            fn: async (row: BankingReferenceTable) => {

              await this.companyModal.show(this.companyBankingReferenceForm.at(row.code) as FormGroup,
                (f: FormGroup) => {
                  this.companyBankingReferenceForm.removeAt(row.code);
                  this.companyBankingReferenceForm.insert(row.code, f);
                  this.updateTable(f, row.code);
                });
            },
            icon: "fa fa-pencil",
            isDisabled: false,
            tooltip: "Editar",
            disabledFn: () => { return this.disabled; }
          },
          {
            fn: async (row: BankingReferenceTable) => {
              const result = await this.confirmService.showAsync("Advertencia", "¿Está seguro de eliminar el registro?", ModalDialogType.WARNING);
              if (result) {
                this.companyBankingReferenceForm.removeAt(row.code);
                this.deleteFromTable(row.code);
              }
            },
            icon: "fa fa-trash",
            isDisabled: false,
            tooltip: "Delete",
            disabledFn: () => { return this.disabled; }
          }
        ]
      }),
    ];
  }

  private deleteFromTable(code: number) {
    this.bankingReferenceTable.content = this.bankingReferenceTable.content.filter(f => f.code != code);
    this.updateCodes(this.bankingReferenceTable.content);
    this.bankingReferenceTable = new Paging(this.bankingReferenceTable.content);
  }

  async addReference() {
    await this.companyModal.show(this.configureNewForm(), (f: FormGroup) => {
      this.companyBankingReferenceForm.push(f);
      this.companyBankingReferenceForm.markAsDirty();
      if (!this.isEdit) {
        this.updateTable(f);
      }
    });
  }

  private updateTable(f: FormGroup, code?: number) {

    let bankingReference = new BankingReferenceTable();
    if (code != undefined) {
      bankingReference = this.bankingReferenceTable.content.find(f => f.code == code) || new BankingReferenceTable();
    }
    bankingReference.name = `${f.value.institutionName}`;
    bankingReference.phone = f.value.phone;
    bankingReference.relationshipType = this.contactPositions.find(s => s.key == f.value.relationshipType)?.value || f.value.relationshipType;
    bankingReference.status = f.valid;
    if (code == undefined) {
      this.bankingReferenceTable.content.push(bankingReference);
    }

    this.updateCodes(this.bankingReferenceTable.content);
    this.bankingReferenceTable = new Paging(this.bankingReferenceTable.content);
  }

  configureNewForm() {
    let form = new FormGroup({
      name: new FormControl("", Validators.required),
      institutionName: new FormControl("", Validators.required),
      relationshipInitialDate: new FormControl("", Validators.required),
      phone: new FormControl("", Validators.required),
      phoneExtension: new FormControl(""),
      relationshipType: new FormControl("", Validators.required),
    });

    form.get("relationshipType")?.markAsDirty()
    return form;
  }
  private updateCodes(content: BankingReferenceTable[]) {
    content.forEach((f, i) => f.code = i);
  }
}

